import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { EmailCampaign } from '../EmailCampaign';
import { RouteConstants } from '@/features/router/RouteConstants';
import { EmailCampaignGateGuard } from '../components/EmailCampaignGateGuard';

export const CampaignsEmailCreateFlowV2: FC = () => {
  const history = useHistory();

  const handleExitToList = () => {
    history.push(RouteConstants.emailCampaigns);
  };

  return (
    <EmailCampaignGateGuard>
      <EmailCampaign mode='create' onExitToList={handleExitToList} />
    </EmailCampaignGateGuard>
  );
};
